import { Card, CardContent } from '../ui/card';
import { Star } from 'lucide-react';

const TESTIMONIALS = [
  {
    id: 'sarah-m',
    quote: 'MLC TECH transformed our IT from a constant headache to something we never have to think about. Their team responds fast and actually fixes problems the first time.',
    author: 'Sarah Mitchell',
    role: 'Operations Director',
    company: 'Phoenix Medical Group',
    stars: 5,
  },
  {
    id: 'david-c',
    quote: 'We switched from a big-name MSP and cut our IT costs by 40% while getting better service. The team at MLC TECH actually understands small business needs.',
    author: 'David Chen',
    role: 'CEO',
    company: 'Apex Manufacturing',
    stars: 5,
  },
  {
    id: 'jennifer-t',
    quote: 'After a ransomware scare, MLC TECH helped us implement proper security and backup systems. I sleep better knowing our data is protected.',
    author: 'Jennifer Torres',
    role: 'Office Manager',
    company: 'Southwest Law Associates',
    stars: 5,
  },
];

export function Testimonials() {
  return (
    <section className="py-24 bg-slate-950 relative overflow-hidden noise-overlay" data-testid="testimonials-section">
      <div className="absolute top-0 left-1/3 w-96 h-96 bg-blue-600 rounded-full opacity-5 blur-[150px]" />
      <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-cyan-500 rounded-full opacity-5 blur-[120px]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
            Trusted by Businesses Like Yours
          </h2>
          <p className="text-lg text-slate-400">Real results from real clients.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <Card key={t.id} className="testimonial-card bg-slate-800/50 border-slate-700/50 backdrop-blur-sm" data-testid={`home-testimonial-${t.id}`}>
              <CardContent className="p-7">
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: t.stars }, (_, i) => (
                    <Star key={`${t.id}-star-${i}`} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-slate-300 mb-6 leading-relaxed text-sm">"{t.quote}"</p>
                <div className="border-t border-slate-700/50 pt-4">
                  <p className="font-semibold text-white text-sm">{t.author}</p>
                  <p className="text-xs text-slate-400">{t.role}</p>
                  <p className="text-xs text-blue-400">{t.company}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
